import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

const integrationCardQueries = graphql`
  query {
    ...IntegrationsCardsFragment
  }
`;

const IntegrationsCards = () => {

  const data = useStaticQuery(integrationCardQueries);

  return (
    <>
      {data.allIntegrationsJson.nodes.map(integrations => {
        const image = data.allFile.nodes.find(
          n => n.name === integrations.Logo
        ).publicURL
        return (
          <div className="article-card column is-3-desktop is-4-tablet is-12-mobile">
            <a
              className="card-link"
              href={integrations.Url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="card-container clickable-card integrations-card">
                <img
                  src={image}
                  className="card-image"
                  title={integrations.name}
                  alt=""
                />
              </div>
            </a>
          </div>
        )
      })}
    </>
  )
}

export default IntegrationsCards
